import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AlbumItemThumbnail } from '../../album-view/components/album-item-thumbnail';


import '../../album-view/style/album.scss';

class SnapfishAlbumItemView extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {

        };

		this.selectItem = this.selectItem.bind(this);
		this.amISelected = this.amISelected.bind(this);
    }

    selectItem(albumItem) {
        if(this.props.selectItem) {
            this.props.selectItem(albumItem);
        }

	}

	amISelected(theSet, id){

		const setArray = Array.from(theSet);


		var found = setArray.find(function(element) {
			return element.id ===id;
		  });

		  if(found){
			  return true;
		  }
		  return false;
		}

	render() {
		var myAlbumTitle = '';
		var myAlbumDesc = '';
		const { albumItems, selectedItems, albums } = this.props;

		if (this.props.albumId > 0){

			myAlbumTitle = albums.get(this.props.albumId).title;
			myAlbumDesc = albums.get(this.props.albumId).description;
		}

        const title = (
            <div>
                <div className="album-title-text">{myAlbumTitle}</div>
                <div className="album-description-text">{myAlbumDesc}</div>
            </div>
		);

		var dispOrder = 0;

		if(!this.props.isVisible) return <span/>;

		return (



				<div className="snapfish-album-item" ref={viewContainer => (this.viewContainer = viewContainer)}>
					<div className="right-side" id="content-layout">
					<div
				className="snapfish-aware-container"
				ref={thisContainer => (this.container = thisContainer)}
			>
				<div className="view-title-text">{title}</div>




				{[...albumItems.values()].map(albumItem => {
					dispOrder += 1;
					const isSelected = this.amISelected(selectedItems,albumItem.id);

					return (
						<AlbumItemThumbnail
							key={`albumItem.${albumItem.id}`}
							albumItemId={albumItem.id}
							image={albumItem.pickerThumbnail}
							title={albumItem.title}
							onLoad={()=>{}}
                            selectMode={true}
							selectItem={()=>this.selectItem(albumItem)}
							selected={isSelected}
							albumItemDisplayOrder={dispOrder}
						/>
					);
				})}
			</div>
				</div>
				</div>
		);
	}
}

SnapfishAlbumItemView.propTypes = {
    selectItem: PropTypes.func.isRequired,
    albumItems: PropTypes.object.isRequired,
    loadAdditionalAlbumItems: PropTypes.func.isRequired,
    requestMade: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
	return {
		albumItems: state.snapfish.snapfishPhotoElements,
		albums: state.snapfish.snapfishCollections,
		selectedItems: state.snapfish.snapfishSelectedElements
	};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SnapfishAlbumItemView);



// WEBPACK FOOTER //
// ./src/snapfish/components/snapfish-album-item-view.jsx